module.exports = __webpack_public_path__ + "media/images/redesign-images/home-new/ig-images/ig-08-7c968145c040f7c7463d3f51e08f670b.jpg";